import BlockTabsWithBannerGraphql from '~/components/Organisms/BlockTabsWithBannerGraphql.vue';


export default {
  __name: 'BlockAdviceTabsWithBannerGraphql',
  props: {
  background: {
    type: Object,
    default: () => {},
  },
  title: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
  linkText: {
    type: String,
    default: '',
  },
  tabsCollection: {
    type: Object,
    default: () => {},
  },
  advicePage: {
    type: Object,
    default: () => {},
  },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props, BlockTabsWithBannerGraphql }
}

}